import React from 'react';

import Tag from '@atlaskit/tag';
import TagGroup from '@atlaskit/tag-group';

export default (): React.JSX.Element => (
	<TagGroup label="Atlassian apps" alignment="start">
		<Tag text="Bitbucket" />
		<Tag text="Compass" />
		<Tag text="Confluence" />
		<Tag text="Jira" />
		<Tag text="Jira Service Management" />
		<Tag text="Jira Software" />
		<Tag text="Jira Work Management" />
		<Tag text="Opsgenie" />
		<Tag text="Statuspage" />
		<Tag text="Trello" />
	</TagGroup>
);
